<div class="auto-complete">
    <div class="tem-field">
        <label class="tem-field-label" *ngIf="labelName">{{labelName}}<span class="tem-field-required" *ngIf="required"> *</span></label>
        <nz-input-group [nzSuffix]="suffixTpl">
            <input nz-input
                [(ngModel)]="displayValue"
                (ngModelChange)="onType($event)"
                [nzAutocomplete]="auto"
                [placeholder]="labelName"
                [disabled]="disabled" />
        </nz-input-group>
        <ng-template #suffixTpl>
            <nz-icon *ngIf="isLoading" nzType="loading"></nz-icon>
            <nz-icon *ngIf="!isLoading && displayValue && !disabled" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clear()"></nz-icon>
        </ng-template>
        <nz-autocomplete #auto (selectionChange)="getSelectedAutoComplete($event)">
            <nz-auto-option *ngFor="let option of filteredOptions | async" [nzValue]="option" [nzLabel]="getOptionText(option)">
                <b>{{option.id}} - {{option.name}}</b>
            </nz-auto-option>
        </nz-autocomplete>
    </div>
</div>
